import Icon from 'bee-icon'

export default Icon
